module.exports = __webpack_public_path__ + "static/media/mia.e88ad940.jpg";